import { jsx as o } from "react/jsx-runtime";
import { c as r } from "./createSvgIcon.js";
const c = r(/* @__PURE__ */ o("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), "KeyboardArrowRight");
export {
  c as K
};
